import { Component } from '@angular/core';

@Component({
  selector: 'fgb-facial-id-page',
  templateUrl: './facial-id-page.component.html',
  styleUrls: ['./facial-id-page.component.scss'],
})
export class FacialIdPageComponent {}
